module.exports = __webpack_public_path__ + "media/images/instagram_black-d4024b0f.svg";